import * as _ from 'lodash';
import { System } from '../../System';
import { Notification } from '../NotificationStore';
import { Routes } from '../../routes';
import { autorun } from 'mobx';
import { DeveloperInviteModel } from '@journeyapps-platform/lib-journey-core';
import { DeveloperInviteStatus } from '@journeyapps-platform/types-accounts-hub';

export class InvitationNotification extends Notification {
  constructor(public i: DeveloperInviteModel) {
    super({
      text: `You have been invited to the organization ${i.orgName} with roles: ${(
        i.model.metadata.role_names ?? []
      ).join(', ')}`,
      action: (n) => {
        n.navigate(Routes.PROFILE_ORGANIZATIONS);
      },
      label: 'Organization invite',
      date: new Date()
    });
  }
}

/**
 * This currently only shows shows notifications as pending invites are present in the
 * profile store. This could be improved by polling developer invites or by streaming from
 * a future notification service.
 */
export const hackSetupInviteNotifications = (system: System) => {
  const existing = new Set<string>();

  autorun(() => {
    const pendingInvites = system.profileStore.invitations.items.filter((invite: DeveloperInviteModel) => {
      return invite.options.model.status == DeveloperInviteStatus.PENDING;
    });

    // Accepting or denying an invite should clear the notification
    const removedInvitations = _.difference(
      Array.from(existing.values()),
      pendingInvites.map((item) => item.id)
    );

    removedInvitations.forEach((id) => {
      existing.delete(id);
      // Clear the notification also
      const invalidNotification = Array.from(system.notificationStore._notifications.values()).find(
        (notification) => (notification as InvitationNotification).i?.id == id
      );
      invalidNotification?.close();
    });

    pendingInvites.forEach((i) => {
      if (existing.has(i.id)) {
        return;
      }
      existing.add(i.id);
      system.notificationStore.addNotification(new InvitationNotification(i));
    });
  });
};
